import uuid from "../../../library/uuid.js";
import global from "../../global.js";
import ObjectHandle from "../ObjectHandle.js";
const d3 = global.d3;

const log = global.log.getLogger("f_mtac.scene.drivers.CurvedArrowLine");
log.setLevel(log.levels.WARN);

import {simplify} from "svg-utils";
    
const CurvedArrowLine = function(group, color) {
    this.data = {
        id: `local-${uuid()}`,
        segments_number: 0,
        segments: [[]],
        color: color,
        class: ["node", "line", "object", "movable", "removable"],
        storage: "object"
    };
    this.group = group;
    this.handle = null;
    this.node = null;
    this.arrow_group = null;
    this.arrow_line = null;
    this.arrow_head = null;
    this.position = null;
    this.initial_position = null;
};
CurvedArrowLine.prototype.render_driver = d3.line().x((d) => d.x).y((d) => d.y).curve(d3.curveLinear);
CurvedArrowLine.prototype.render = function() {
    const data = this.data.segments.reduce((s1, s2) => s1.concat(s2));
    return this.render_driver(simplify(data, 3 / global.scene.root_transform.k, true));
};
CurvedArrowLine.prototype.draw = function(x, y) {
    this.group.select(`#${this.data.id}`).remove();
    this.handle = this.group.append("g").attr("class", "handle").attr("id", this.data.id);
    this.node = this.handle.append("g").attr("class", this.data.class.join(" "));
    this.arrow_group = this.node.append("g");
    this.data.segments[0].push({x, y});
    this.position = {x, y};
    this.arrow_line = this.node.append("path")
        .attr("stroke", this.data.color).attr("stroke-width", 3)
        .attr("stroke-dasharray", "10, 5")
        .attr("d", this.render());
    this.arrow_head = this.arrow_group.append("polygon")
        .attr("class", "arrow_head")
        .attr("stroke", this.data.color).attr("stroke-width", 3).attr("stroke-opacity", 1)
        .attr("fill", this.data.color).attr("fill-opacity", 1);

    let object_handle = ObjectHandle({x, y, color: this.data.color});
    this.node.append(() => object_handle.node());
    this.initial_position = {x, y};
};

const get_angle = (dx, dy) => {
    var angle;
    if (dx === 0) {
        if (dy < 0) {
            angle = - Math.PI / 2;
        } else {
            angle = Math.PI / 2;
        }
    } else if (dx > 0) {
        angle = Math.atan(dy/dx);
    } else if (dx < 0) {
        angle = Math.atan(dy/dx) - Math.PI;
    }
    angle = angle / (2 * Math.PI) * 360;
    return angle;
};

CurvedArrowLine.prototype.update = function(x, y) {
    let dx = x - this.position.x;
    let dy = y - this.position.y;
    // check size of segment
    if ( Math.sqrt(Math.pow(dx, 2) + Math.pow(dy, 2)) < 5 / global.scene.root_transform.k) {
        return;
    }

    // add segment
    const a = 60, b = 30, /*sa = 40, sb = 20,*/ sw=3;
    let angle = get_angle(dx, dy);
    let N = this.data.segments_number;

    this.data.segments[N].push({x, y});
    this.arrow_line
        .attr("stroke", this.data.color).attr("stroke-width", 3)
        .attr("fill", "none")
        .attr("d", this.render());

    let arrow_head_points = [[x , y], [x - a , y - b], [x - a , y + b]]
        .map(p => p.join(","))
        .join(" ");

    this.arrow_head.attr("stroke", this.data.color).attr("stroke-width", sw).attr("stroke-opacity", 1)
        .attr("fill", this.data.color).attr("fill-opacity", 1)
        .attr("points", arrow_head_points)
        .attr("transform-origin", `${x}px ${y}px`);

    this.arrow_group.attr("transform", `rotate(${angle})`)
        .attr("transform-origin", `${x}px ${y}px`);

    this.position.x = x;
    this.position.y = y;

    /*this.timer = window.setTimeout(() => {
        let N = this.data.segments_number;
        this.data.segments[N] = [this.data.segments[N].shift(), this.data.segments[N].pop()];
        dx = x - this.initial_position.x;
        dy = y - this.initial_position.y;
        angle = get_angle(dx, dy);
        this.arrow_group.attr("transform", `rotate(${angle})`);

        //calcul milieu segment N et ajout fleche
        let dxs = this.data.segments[N][1].x - this.data.segments[N][0].x;
        let dys = this.data.segments[N][1].y - this.data.segments[N][0].y;
        let mid_segment = {x : this.data.segments[N][0].x + dxs / 2 , y : this.data.segments[N][0].y + dys / 2};
        let segment_angle = get_angle(dxs, dys);
        let arrow_segment_group = this.node.append("g");
        arrow_segment_group.attr("transform", `rotate(${segment_angle})`)
            .attr("transform-origin", `${mid_segment.x}px ${mid_segment.y}px`);
        let arrow_segment_points = [[mid_segment.x , mid_segment.y], [mid_segment.x - sa , mid_segment.y - sb], [mid_segment.x - sa , mid_segment.y + sb]]
            .map(p => p.join(","))
            .join(" ");
        arrow_segment_group.append("polygon")
            .attr("class", "arrow_segment")
            .attr("stroke", this.data.color).attr("stroke-width", 3).attr("stroke-opacity", 0.4)
            .attr("fill", this.data.color).attr("fill-opacity", 0.2)
            .attr("points", arrow_segment_points)
            .attr("transform-origin", `${mid_segment.x}px ${mid_segment.y}px`);

        this.data.segments.push([this.data.segments[N][1]]);
        this.initial_position = { x: this.data.segments[N][1].x, y: this.data.segments[N][1].y};
        this.data.segments_number = N + 1;
        this.arrow_line
            .attr("stroke", this.data.color).attr("stroke-width", 3)
            .attr("fill", "none")
            .attr("d", this.render());
        this.arrow_head
            .attr("stroke", this.data.color).attr("stroke-width", sw).attr("stroke-opacity", 1)
            .attr("fill", this.data.color).attr("fill-opacity", 1)
            .attr("points", arrow_head_points)
            .attr("transform-origin", `${x}px ${y}px`);
    }, 500);
    */
};
CurvedArrowLine.prototype.end = function() {
    return Promise.resolve();
};
CurvedArrowLine.prototype.is_empty = function() {
    let N = this.data.segments_number;
    return (this.data.segments[N].length === 0);
};
CurvedArrowLine.prototype.detach = function() {
    this.handle = null;
    this.node = null;
    this.arrow_group = null;
    this.arrow_line = null;
    this.arrow_head = null;
};
CurvedArrowLine.prototype.export = function() {
    return this.handle;
};
export default CurvedArrowLine;
